import  { useEffect } from 'react'
import AuthLayout from '../layouts/AuthLayout'
import { Box, IconButton, Typography,Input} from '@mui/material'
import SearchIcon from "@mui/icons-material/Search";
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSort from '../events/hooks/useSort';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import Header from '../userfiles/components/Header';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import UsersTable from './components/UsersTable';
import usePendingVerificationActions from './usePendingVerificationActions';
import { setUserState } from '../../redux/userManagementSlice';
import SignupRequestStatusFilter from './components/SignupRequestStatusFilter';
import { requestStatusFilterOptions } from '../../constants/staticData';
import ViewOrganisationMembersPopup from '../dashboard/components/ViewOrganisationMembersPopup';
import InviteOrganisationMembersPopup from '../dashboard/components/InviteOrganisationMembersPopup';
import ChangeMemberRoleConfirmationPopup from '../dashboard/components/ChangeMemberRoleConfirmationPopup';
import RemoveOrganisationMemberConfirmationPopup from '../dashboard/components/RemoveOrganisationMemberConfirmationPopup';


 const PendingVerification = () => {

    const [selectedSortbyValue, setSelectedSortbyValue] = useState(null);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const userReducer = useSelector((state) => state.userReducer);
      const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
       const teamsReducer = useSelector((state) => state.root.teamsReducer);
   
    const [searchTerm, setSearchTerm] = useState('');
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const emailMatch = location.search.match(/[?&]email=([^&]*)/)
    const highlightEmail = emailMatch ? decodeURIComponent(emailMatch[1]) : ''
    const handleBack = () => highlightEmail ? navigate('/dashboard') : navigate(-1)
    const clearHighlight = () => navigate(location.pathname, { replace: true })
    
   
    const [searchedArray, setSearchedArray] = useState([ ...(userReducer?.unapproved_users || []),...(userReducer?.unverified_users || [])])
    const [sortedFiles] = useSort(searchedArray, selectedSortbyValue)
    const {getUnapprovedUsersList, getUnverifiedUsersList} = usePendingVerificationActions()
   





      const handleSearch = (e) => {
        const searchedInput = e.target.value.toLowerCase();
        setSearchTerm(searchedInput);

        const updatedFiles = [ ...(userReducer?.unapproved_users || []),...(userReducer?.unverified_users || [])];
   
        const results = updatedFiles?.filter(item =>
          item?.name?.toLowerCase().includes(searchedInput) ||
          item?.organisation_name?.toLowerCase().includes(searchedInput)||
          item?.email?.toLowerCase().includes(searchedInput)
        );
        setSearchedArray(results);
      };


 
 

  
     useEffect(()=>{
       getUnapprovedUsersList();
       getUnverifiedUsersList();
     },[])

     useEffect(()=>{
       const combined = [ ...(userReducer?.unapproved_users || []),...(userReducer?.unverified_users || [])]
       const sorted = highlightEmail
         ? [
             ...combined.filter(u => u?.email?.toLowerCase() === highlightEmail.toLowerCase()),
             ...combined.filter(u => u?.email?.toLowerCase() !== highlightEmail.toLowerCase()),
           ]
         : combined
       setSearchedArray(sorted)
       console.log("sorted", sorted)
       //console.log("highlightEmail", highlightEmail)
       dispatch(setUserState({all_users: sorted}))
     },[userReducer?.unverified_users, userReducer?.unapproved_users])
     

    

    

  return (
    <AuthLayout sx={{ padding: '2.1% 3.4% 2.1% 3.4%'}}>
        <Header/>
        <Box px={{xs:1.5, sm:2, md:3}} pr={{xs:1.5, sm:3, md:6}} className='flex col' mt={4}>
              <Box sx={{display:'flex', justifyContent:'start', alignItems:'center', color:'black', mb:2}} gap={1}>
                      <KeyboardBackspaceOutlinedIcon onClick={handleBack} sx={{color:'black', cursor:'pointer' }}/>
                    <Typography sx={{fontFamily: 'Rubik', fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'14px',xl:'20px'}}}>
                      {highlightEmail ? 'Back to Dashboard' : 'Back'}
                    </Typography>
                  </Box>
            <Box className='flex j-between' mb={3}>
                <Box sx={{ display:'flex', flexDirection:{xs:'column', md:'row'}, alignItems:{xs:'flex-start', md:'center'}, justifyContent:'space-between', gap:{xs:1.5, md:4}, width:'100%'}}>
                  <Box>
                    <Typography sx={{color:'#000000', fontFamily:'Rubik', fontWeight:600, fontSize:{xs:'16px',md:'18px',lg:'20px',xl:'30px'}}}>User Management</Typography>
                    <Typography sx={{color:'#000000', fontFamily:'Rubik',  fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'20px'}}}>Approve or reject a new signup request, resend verification mail for approved users.</Typography>
                  </Box>
                  <Box sx={{display:'flex', flexDirection:{xs:'column', sm:'row', md:'row'}, alignItems:{xs:'stretch', sm:'center', md:'center'}, justifyContent:'end', gap:{xs:1, sm:2, md:4}, width:{xs:'100%', md:'auto'}}}>
                    <Box id="search">
                        <Input
                        value={searchTerm}
                        onChange={handleSearch}
                        inputProps={{ maxLength: 100 }}
                        sx={{
                            width:{xs:'100%', sm:'auto'},
                            borderBottom: 2,
                            borderColor: "#333333",
                            input: {
                                fontSize: { xs: '12px', md: '13px', lg: '14px', xl: '20px' },
                                fontWeight: 400,
                                color: "#000000",
                            },
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:1, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'17px',xl:'24px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box>
                    <SignupRequestStatusFilter
                      sortByOptions={requestStatusFilterOptions}
                      selectedSortbyValue={selectedSortbyValue}
                      setSelectedSortbyValue={setSelectedSortbyValue}
                      menuTitle = "Request Status"
                    />
                    </Box>
                </Box>
                <Box className='flex a-center' gap={2}>   
                      
                </Box>
            </Box>
          
            <UsersTable
                // files={searchedArray}
                files={sortedFiles}
                highlightEmail={highlightEmail}
                onActionSuccess={clearHighlight}
            />
        </Box>
         {commonReducer.invite_org_members_popup == true && <InviteOrganisationMembersPopup options={dropdownReducer?.organisation_roles}/>}
        
        {commonReducer.view_members_popup == true && <ViewOrganisationMembersPopup  options={dropdownReducer?.organisation_roles}/>}

     {teamsReducer.remove_member_confirmation_popup == true && <RemoveOrganisationMemberConfirmationPopup/>}

         {commonReducer?.change_member_role_confirmation_popup == true && <ChangeMemberRoleConfirmationPopup/>}
    </AuthLayout>
  )
}

export default PendingVerification